export const SET_FEED_DATA = "SET_FEED_DATA";
export const SET_FEED_FILTER = "SET_FEED_FILTER";
export const SET_NAVBAR_FEED_FILTER = "SET_NAVBAR_FEED_FILTER";
export const SET_FEED_HOME_BANNER = "SET_FEED_HOME_BANNER";
export const UPDATE_KEYS_OF_POST = "UPDATE_KEYS_OF_POST";
export const SET_USER_DATA = "SET_USER_DATA";
export const SET_USER_TAGS = "SET_USER_TAGS";
export const SET_USER_STREAK = "SET_USER_STREAK";
export const SET_DETAIL_VIEW_POST = "SET_DETAIL_VIEW_POST";
export const UPDATE_DETAIL_VIEW_POST = "UPDATE_DETAIL_VIEW_POST";
export const REMOVE_POST = "REMOVE_POST";
export const UPDATE_FOLLOW = "UPDATE_FOLLOW";
export const UPDATE_DETAIL_POST_FOLLOW = "UPDATE_DETAIL_POST_FOLLOW";
export const SET_SHOW_SIMILAR_POLLS = "SET_SHOW_SIMILAR_POLLS";
export const SET_STORY_BUBBLES_DATA = "SET_STORY_BUBBLES_DATA";
export const REWARDS_USER_ACTION = "REWARDS_USER_ACTION";
export const SET_STREAKS_REWARD_EARNED = "SET_STREAKS_REWARD_EARNED";
export const SET_MULTI_REWARDS_DATA = "SET_MULTI_REWARDS_DATA";
export const SET_SHOW_SEVENTH_DAY_REWARD_POPUP =
  "SET_SHOW_SEVENTH_DAY_REWARD_POPUP";
export const SET_SHOW_HOME_PAGE_ANIMATION = "SET_SHOW_HOME_OAGE_ANIMATION";
